import { Component, OnInit } from "@angular/core";
import { ModalController, NavController, NavParams } from "@ionic/angular";
import { AlertandloadingService } from "src/app/services/alertandloading.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-withdraw-kaudi",
  templateUrl: "./withdraw-kaudi.page.html",
  styleUrls: ["./withdraw-kaudi.page.scss"],
})
export class WithdrawKaudiPage implements OnInit {
  securityCode: string;
  verificationMethod: string = "authenticator";
  selectedWallet: any;
  amount: number;

  activeView: string = "send";
  transactionInfo: any;

  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private navParams: NavParams,
    private alertandLoading: AlertandloadingService,
    public api: ApiService
  ) {
    this.amount = this.navParams.get("amount");
    this.selectedWallet = this.navParams.get("selectedWallet");
  }

  ngOnInit() { this.prepareSecurityVerification(); }

  closeModal() {
    this.modalCtrl.dismiss(this.transactionInfo);
  }

  async submit() {
    if (/^\d{6}$/.test(this.securityCode || "")) {
      await this.alertandLoading.presentLoading(
        "Processing KAUDI waithdrawal please wait"
      );

      let data = {
        to_wallet_id: this.selectedWallet.wallet_id,
        amount: this.amount,
        security_code: this.securityCode,
      };

      this.api.withdrawKaudi(data).then(
        (result: any) => {
          this.alertandLoading.dismissLoading();
          if (!result.error) {
            console.log(result);
            this.transactionInfo = result.data.transaction;
            this.activeView = "result";
          } else {
            this.securityCode = "";
            this.alertandLoading.showAlert(
              "Alert",
              "Oops something went wrong please try again"
            );
          }
        },
        (error: any) => {
          this.alertandLoading.dismissLoading();
        }
      );
    } else {
      this.alertandLoading.showAlert(
        "Verification required",
        "Enter the current 6 digit security code"
      );
    }
  }

  async openTwoFactorSetup() {
    await this.modalCtrl.dismiss();
    this.navCtrl.navigateForward("settings/2fa");
  }

  private prepareSecurityVerification() {
    const enabled = this.api.usersession &&
      (this.api.usersession.two_factor_enabled === true || this.api.usersession.two_factor_enabled == 1);
    this.verificationMethod = enabled ? "authenticator" : "setup";
  }
}
